/* eslint-disable import/no-unresolved */
const constants = require('onestic-base/constants');
const debounce = require('lodash/debounce');
const utils = require('onestic-base/utils');

const checkDots = (element) => {
    let dots = false;

    if (element.hasClass('mobile-slider')) {
        dots = true;
        element.find('.banner-link > .text-block').css('bottom', '40px');
    }

    return dots;
};

const runSlick = (element) => {
    const { prev, next } = utils.getSliderLabels();
    $(element).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: checkDots($(element)),
        prevArrow: `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
        nextArrow: `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`,
        mobileFirst: true,
        infinite: true,
        responsive: [
            {
                breakpoint: constants.viewport_bootstrap.md,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: constants.viewport_bootstrap.lg,
                settings: 'unslick',
            },
        ],
    });
};

const runSlickSmall = (element) => {
    const { prev, next } = utils.getSliderLabels();
    const $element = $(element);
    const desktopItems = parseInt($element.attr('data-desktop-items'), 10);
    const tabletItems = parseInt($element.attr('data-tablet-items'), 10);
    const mobileItems = parseInt($element.attr('data-mobile-items'), 10);
    const autoplay = $element.attr('data-autoplay');
    const autoplaySpeed = parseInt($element.attr('data-autoplay-speed'), 10);

    const smallCarousel = $element.find('.carousel-small');

    smallCarousel.not('.slick-initialized').slick({
        slidesToShow: mobileItems,
        slidesToScroll: mobileItems,
        dots: checkDots($element),
        prevArrow: `<button type="button" class="icon-left-arrow-line small prev no-btn" aria-label="${prev}"></button>`,
        nextArrow: `<button type="button" class="icon-right-arrow-line small next no-btn" aria-label="${next}"></button>`,
        mobileFirst: true,
        infinite: true,
        autoplay: autoplay === 'true',
        autoplaySpeed: autoplaySpeed,
        responsive: [
            {
                breakpoint: constants.viewport_bootstrap.md,
                settings: {
                    slidesToShow: tabletItems,
                    slidesToScroll: tabletItems,
                },
            },
            {
                breakpoint: constants.viewport_bootstrap.lg,
                settings: {
                    slidesToShow: desktopItems,
                    slidesToScroll: desktopItems,
                },
            },
        ],
    });
};

// eslint-disable-next-line consistent-return
const checkElement = (selector, fn) => {
    if ($(selector).length) {
        fn();
        return;
    }
    setTimeout(() => {
        checkElement(selector, fn);
    }, 100);
};

const slickConfig = () => {
    const debounceTime = 500;
    const containersMobileSlider = $('.mobile-slider');
    if (containersMobileSlider.length) {
        checkElement('.mobile-slider', runSlick.bind(null, '.mobile-slider'));

        $(window).on('resize orientationchange', debounce(() => {
            checkElement('.mobile-slider', runSlick.bind(null, '.mobile-slider'));
        }, debounceTime));
    }

    const smallBannerSlider = $('.banner-carousel-small');
    if (smallBannerSlider.length) {
        checkElement('.banner-carousel-small', runSlickSmall.bind(null, '.banner-carousel-small'));

        $(window).on('resize orientationchange', debounce(() => {
            checkElement('.banner-carousel-small', runSlickSmall.bind(null, '.banner-carousel-small'));
        }, debounceTime));
    }
};

export default () => {
    slickConfig();
};
